/* Havin Bag - barre d'achat collante de la fiche produit, sur mobile (17/09/2026).
   Reprise de la barre de la boutique soeur : prenom du sac et prix a gauche,
   bouton « Add to cart » a droite, fond greige, en bas de l'ecran.
   - Elle n'apparait QUE quand le vrai bouton d'achat est sorti de l'ecran.
   - Elle ne fait que declencher ce vrai bouton (jamais un second formulaire,
     sinon la variante choisie serait desynchronisee).
   - Son libelle, son etat et son prix suivent le vrai bouton et le vrai prix
     (rupture, changement de coloris, prix solde plutot que prix barre).
   Chargee par layout/theme.liquid sur les fiches produit seulement ; styles dans
   assets/havinbag.css (bloc « barre d'achat collante »), visible sous 750 px. */
(function () {
  function prixAffiche() {
    var zone = document.querySelector('.product__info-container .price');
    if (!zone) return '';
    var solde = zone.classList.contains('price--on-sale') ? zone.querySelector('.price-item--sale') : null;
    var el = solde || zone.querySelector('.price-item--regular');
    return el ? el.textContent.trim() : '';
  }

  function barreCollante() {
    var form = document.querySelector('.product__info-container .product-form__buttons');
    var vraiBouton = form && form.querySelector('button[name="add"], .product-form__submit');
    if (!form || !vraiBouton) return;
    if (document.querySelector('.hb-sticky')) return;

    /* le titre est en deux morceaux : .product__name (le prenom du sac) et
       .product__desc (le reste) ; seul le prenom tient dans une barre etroite */
    var titre = document.querySelector('.product__title .product__name') || document.querySelector('.product__title h1, .product__title');

    var barre = document.createElement('div');
    barre.className = 'hb-sticky';
    barre.setAttribute('aria-hidden', 'true');
    barre.innerHTML =
      '<span class="hb-sticky__x">' +
      '<span class="hb-sticky__t"></span>' +
      '<span class="hb-sticky__p"></span>' +
      '</span>' +
      '<button type="button" class="hb-sticky__b" tabindex="-1">Add to cart</button>';
    barre.querySelector('.hb-sticky__t').textContent = titre ? titre.textContent.trim() : '';
    document.body.appendChild(barre);

    var bouton = barre.querySelector('.hb-sticky__b');
    bouton.addEventListener('click', function () {
      vraiBouton.click();
    });

    var miroir = function () {
      bouton.disabled = vraiBouton.disabled;
      var libelle = vraiBouton.querySelector('span');
      if (libelle && libelle.textContent.trim()) bouton.textContent = libelle.textContent.trim();
      barre.querySelector('.hb-sticky__p').textContent = prixAffiche();
    };
    miroir();
    new MutationObserver(miroir).observe(form, { subtree: true, childList: true, attributes: true, characterData: true });
    var zonePrix = document.querySelector('.product__info-container [id^="price-"]');
    if (zonePrix) new MutationObserver(miroir).observe(zonePrix, { subtree: true, childList: true, characterData: true });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entrees) {
          var visible = entrees[0].isIntersecting;
          barre.classList.toggle('is-on', !visible);
          barre.setAttribute('aria-hidden', visible ? 'true' : 'false');
          bouton.tabIndex = visible ? -1 : 0;
        },
        { threshold: 0 }
      ).observe(form);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', barreCollante);
  } else {
    barreCollante();
  }
})();
